import React, { useState, useRef, useEffect } from 'react';
import { 
  Box, Button, Stack, Grid,FormControlLabel,Radio, RadioGroup, 
  Typography, Paper,Chip,Alert,Autocomplete,
  CircularProgress, TextField, ToggleButton, ToggleButtonGroup, 
  Snackbar
} from '@mui/material';

import SendIcon from '@mui/icons-material/Send';
import SignatureCanvas from 'react-signature-canvas';
import { grey } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ReturnIcon from '@mui/icons-material/KeyboardReturn';

import BASE_URL from '../../config'

const Inputstyle = {
      '& .MuiOutlinedInput-root': {
        bgcolor: 'white',
        borderRadius: '8px',
        '& fieldset': { borderColor: 'transparent' },
        '&:hover fieldset': { borderColor: grey[400] },
        '&.Mui-focused fieldset': { borderColor: grey[600] },
      },
    };

const Inputstyle2 = {
  mx:2,
  '& .MuiOutlinedInput-root': {
    bgcolor:grey[200],
    borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
  },
};

export default function ReporteNuevo({ reporte, alCerrar }) {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [loading, setLoading] = useState(false);
  const [formato, setFormato] = useState('digital');
  const [pdfArchivoUrl, setPdfArchivoUrl] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [emailsCC, setEmailsCC] = useState([]); 
  const [urls, setUrls] = useState({ antes: '', despues: '', firma_encargado_foto: '', firma_cliente_foto: '' });
  const [errorForm, setErrorForm] = useState(false); 
  const [checkList, setCheckList] = useState([]);
  
  // Estado para el panel de envío (se activa tras guardar)
  const [reporteGuardado, setReporteGuardado] = useState(false);
  const [emailDestino, setEmailDestino] = useState(reporte?.email_cliente || '');
  const [mensaje, setMensaje] = useState('');

  const sigEncargado = useRef(null);
  const sigCliente = useRef(null);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const ismailValid = (email) => emailRegex.test(email);

  const mostrarNotificacion = (msg, sev = 'success') => setSnackbar({ open: true, message: msg, severity: sev });

  useEffect(() => {
    const cargarTareas = async () => {
      setLoading(true);
      try {
        // Usamos el endpoint que creamos anteriormente
        const response = await fetch(`${BASE_URL}/reportes/checklist/${reporte.reporte_id}`);
        const data = await response.json();
        if (data.success) {
          setCheckList(data.data); 
        }
      } catch (err) {
        console.error("Error al cargar checklist:", err);
      } finally {
      setLoading(false); 
      }
    };

    if (reporte.reporte_id) {
      cargarTareas();
    }
  }, [reporte.reporte_id]);

  const handleUpload = async (e, tipo) => {
    const file = e.target.files[0];
    if (!file) return;
    if (tipo === 'pdf_checklist' && file.type !== 'application/pdf') return mostrarNotificacion("Solo se admiten archivos PDF", "error");

    setLoading(true);
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch(`${BASE_URL}/reportes/upload`, { method: 'POST', body: formData });
      const data = await response.json();
      if (data.success) {
        if (tipo === 'pdf_checklist'){
        setPdfArchivoUrl(data.url);
        mostrarNotificacion("Archivo PDF cargado correctamente");
        }  
        else if (tipo.includes('firma')) setUrls(prev => ({ ...prev, [`${tipo}_foto`]: data.url }));
        else setUrls(prev => ({ ...prev, [tipo]: data.url }));
      } else {
        mostrarNotificacion(data.message || "No se pudo subir el archivo", "error");
      }
    } catch (err) { mostrarNotificacion("Error al subir el archivo", "error"); }
    finally { 
      setLoading(false); 
      e.target.value = null;
    }
  };

  const guardarNuevoReporte = async () => {

    if (formato === 'foto' && !pdfArchivoUrl) {
      return mostrarNotificacion("Debes subir un archivo antes de guardar", "error");
    }

    setLoading(true);
    try {
      let fEnc = urls.firma_encargado_foto;
      let fCli = urls.firma_cliente_foto;

      if (formato === 'digital') {
        if (!fEnc && sigEncargado.current && !sigEncargado.current.isEmpty()) fEnc = sigEncargado.current.getCanvas().toDataURL('image/png');
        if (!fCli && sigCliente.current && !sigCliente.current.isEmpty()) fCli = sigCliente.current.getCanvas().toDataURL('image/png');
      }

      const payload = { 
        reporte_id: reporte.reporte_id,
        formato,
        archivo_pdf_url: pdfArchivoUrl,
        foto_antes: urls.antes,
        foto_despues: urls.despues,
        firma_encargado: fEnc,
        firma_cliente: fCli,
        comentarios: observaciones,
        fecha: new Date().toISOString(),
        estado:'cargado',
        check_list: checkList
      };

      const response = await fetch(`${BASE_URL}/reportes/finalizar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        mostrarNotificacion("Reporte creado");
        // El endpoint /preview está protegido con token; un <embed src> directo
        // no envía el header. Lo traemos con fetch (el interceptor añade el token)
        // y lo mostramos como blob.
        try {
          const prev = await fetch(`${BASE_URL}/reportes/${reporte.reporte_id}/preview?t=${Date.now()}`);
          if (prev.ok) {
            const blob = await prev.blob();
            setPdfArchivoUrl(URL.createObjectURL(blob));
          }
        } catch (e) { /* el reporte ya se guardó; la previsualización es secundaria */ }
        setReporteGuardado(true);
      } else {
        mostrarNotificacion(data.message || "Error al guardar reporte", "error");
      }
    } catch (err) { mostrarNotificacion("Error de conexión", "error"); }
    finally { setLoading(false); }
  };

  const handleEnviarReporte = async () => {
    const destinoValido = ismailValid(emailDestino);
    const ccValidos = emailsCC.every(email => ismailValid(email));

    if (!emailDestino || !destinoValido || !ccValidos) {
      setErrorForm(true);
      mostrarNotificacion("Por favor, escribe un correo válido en los campos", "error");
      return;
    }

    setLoading(true);

    const data = {
      email_destino: emailDestino,
      cc: emailsCC, 
      mensaje_personalizado: mensaje,
      reporte_id:reporte.reporte_id,
      estado:'enviado'
    };

    try {
      const res = await fetch(`${BASE_URL}/reportes/enviar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      
      const result = await res.json();

        if (res.ok) {
          mostrarNotificacion("Reporte enviado correctamente a todos los destinatarios");
          setTimeout(() => alCerrar(), 2000);
        } else {
          mostrarNotificacion(result.message || "Error al enviar el correo", "error");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error en handleEnviarReporte:", err);
        mostrarNotificacion("Error de conexión con el servidor de correos", "error");
        setLoading(false);
      }
  };

  return (
  <Box sx={{
    gap:3, 
    flexDirection:'column',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    }}>
    <Box sx={{ display:'flex',alignItems:'center',gap:3, flexDirection:'column'}}>
      <Typography variant="h6" align="center" sx={{ fontWeight: 'bold'}}>GENERAR REPORTE TÉCNICO</Typography>

      <Box>
        <ToggleButtonGroup
          value={formato}
          exclusive
          onChange={(e, val) => val && setFormato(val)}
        >
          <ToggleButton value="digital" disabled={formato === 'foto' && pdfArchivoUrl !== ''} sx={{ gap: 1.5,borderRadius:2 }}>
            <DescriptionIcon fontSize="small" />
            <Typography variant="body1" sx={{ fontWeight: 'bold', textTransform: 'none' }}>
              Llenado Digital
            </Typography>
          </ToggleButton>

          <ToggleButton value="foto" sx={{ gap: 1.5 }} 
            disabled={(formato === 'digital') && (reporteGuardado || loading)}>
            <PictureAsPdfIcon fontSize="small" />
              <Typography variant="body1" sx={{ fontWeight: 'bold', textTransform: 'none' }}>
              Subir Archivo PDF
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>  
    </Box>

    <Box sx={{ display:'flex',gap:3, alignItems:'center', flexDirection:'column',width:'100%'}}>
      <Box sx={{display:'flex',flexDirection:'column', width:'100%',gap:2, alignItems:'center',justifyContent:'center'}}>
        {formato === 'digital' ? (
          <Stack spacing={4} >
              {/* SECCIÓN 1: FORMULARIO CHECKLIST */}
              <Box sx={{ width: '100%', overflowX: 'hidden' }}>
                {Object.entries(
                  checkList.reduce((acc, item) => {
                    if (!acc[item.equipo]) acc[item.equipo] = [];
                    acc[item.equipo].push(item);
                    return acc;
                  }, {})
                ).map(([equipo, tareas]) => (
                  <Paper
                    key={equipo}
                    variant="outlined"
                    sx={{ mb: 4, borderRadius: '8px', overflow: 'hidden', border: '2px solid black', width: '100%' }}
                  >
                    <Box sx={{ bgcolor: 'black', p: 1.5 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'white', textTransform: 'uppercase' }}>
                        Equipo: {equipo}
                      </Typography>
                    </Box>

                    <Box sx={{ display: { xs: 'none', md: 'flex' }, bgcolor: 'black', borderBottom: '1px solid white', fontWeight: 'bold' }}>
                      <Box sx={{ width: '40%', p: 1.5, borderRight: '1px solid white', borderTop: '1px solid white', color: 'white' }}>Actividades</Box>
                      <Box sx={{ width: '25%', p: 1.5, borderRight: '1px solid white', borderTop: '1px solid white', color: 'white', textAlign: 'center' }}>Realizado</Box>
                      <Box sx={{ width: '35%', p: 1.5, borderTop: '1px solid white', color: 'white' }}>Comentarios</Box>
                    </Box>

                    {tareas.map((tarea) => {
                      const idx = checkList.findIndex(i => i.tarea_id === tarea.tarea_id && i.equipo === tarea.equipo);
                      return (
                        <Box
                          key={`${tarea.equipo}-${tarea.tarea_id}`}
                          sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            borderBottom: '1px solid #eee',
                            p: { xs: 2, md: 0 },
                            '&:last-child': { borderBottom: 'none' }
                          }}
                        >
                          <Box sx={{ width: { xs: '100%', md: '40%' }, p: { md: 1.5 }, borderRight: { md: '1px solid #eee' }, mb: { xs: 1, md: 0 } }}>
                            <Typography variant="body2" sx={{ fontWeight: { xs: 'bold', md: 'normal' } }}>
                              {tarea.nombre_tarea}
                            </Typography>
                          </Box>

                          <Box sx={{ width: { xs: '100%', md: '25%' }, p: { md: 1 }, borderRight: { md: '1px solid #eee' }, display: 'flex', justifyContent: 'center', bgcolor: { xs: '#fafafa', md: 'transparent' }, borderRadius: { xs: '4px', md: 0 }, mb: { xs: 1, md: 0 } }}>
                            <RadioGroup
                              row
                              value={String(checkList[idx].realizado)}
                              onChange={(e) => {
                                const nuevo = [...checkList];
                                nuevo[idx].realizado = e.target.value === 'true';
                                setCheckList(nuevo);
                              }}
                            >
                              <FormControlLabel value={'true'}  control={<Radio size="small" color="success" />} label={<Typography sx={{ fontSize: '0.8rem' }}>SI</Typography>} />
                              <FormControlLabel value={'false'} control={<Radio size="small" color="error"   />} label={<Typography sx={{ fontSize: '0.8rem' }}>NO</Typography>} />
                            </RadioGroup>
                          </Box>

                          <Box sx={{ width: { xs: '100%', md: '35%' }, p: { md: 1.5 } }}>
                            <TextField
                              fullWidth multiline rows={1} size="small" variant="outlined"
                              placeholder="Escribir comentario..."
                              value={checkList[idx].comentarios}
                              onChange={(e) => {
                                const nuevo = [...checkList];
                                nuevo[idx].comentarios = e.target.value;
                                setCheckList(nuevo);
                              }}
                              sx={{ '& .MuiOutlinedInput-root': { fontSize: '0.8rem', bgcolor: 'white' } }}
                            />
                          </Box>
                        </Box>
                      );
                    })}
                  </Paper>
                ))}
              </Box>

              {/* SECCIÓN 2: EVIDENCIA FOTOGRAFICA */}
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2}}>2. Evidencia Fotográfica</Typography>
                <Box sx={{display:'flex',justifyContent:'space-evenly',flexDirection:{xs:'column',sm:'row'},alignItems:'center',gap:2}}>
                  {['antes', 'despues'].map(tipo => (
                    <Grid item xs={6} key={tipo}>
                      <Box
                        sx={{
                          border: '2px dashed #ccc',
                          borderRadius: 2,
                          p: 1,
                          textAlign: 'center',
                          height: '180px',
                          display: 'flex',
                          aspectRatio: '4 / 3',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          position: 'relative', 
                          bgcolor: '#f9f9f9'
                        }}
                      >
                        {urls[tipo] ? (
                          <>
                            {/*Botón para eliminar la foto*/}
                            <IconButton
                              size="small"
                              onClick={() => setUrls(prev => ({ ...prev, [tipo]: '' }))}
                              sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                bgcolor: 'rgba(255,255,255,0.8)',
                                '&:hover': { bgcolor: '#ffcdd2', color: 'white' },
                                boxShadow: 2
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                            
                            <img
                              src={urls[tipo].startsWith('http') ? urls[tipo] : `${BASE_URL}${urls[tipo]}`}
                              alt={`Evidencia ${tipo}`}
                              style={{ width: '100%', height: '100%', objectFit: 'cover'}}
                            />
                          </>
                        ) : (
                          <Button variant="text" component="label" sx={{ flexDirection: 'column', textTransform: 'none' }}>
                            <Typography variant="subtitle2" color='textSecondary' sx={{ mt: 1 }}>Subir Foto {tipo.toUpperCase()}</Typography>
                            <input 
                              type="file" 
                              hidden 
                              accept="image/png, image/jpeg, image/jpg" 
                              onChange={(e) => handleUpload(e, tipo)} 
                            />
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  ))}
                </Box>
              </Paper>

              {/* SECCIÓN 3: FIRMAS Y NOTAS */}
              <Paper variant="outlined" sx={{ p:2}}>
                <Box sx={{display:'flex',flexDirection:'column',gap:3}}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold'}}>3. Observaciones y Firmas</Typography>
                  <TextField 
                    variant='outlined' 
                    placeholder="Comentarios adicionales" 
                    multiline 
                    sx={Inputstyle2} 
                    rows={3} 
                    value={observaciones} 
                    onChange={(e) => setObservaciones(e.target.value)}
                  />
                  <Box sx={{display:'flex',justifyContent:'space-around',flexDirection:{xs:'column',md:'row'}, gap:3,mx:1}}>
                    {[ {label: 'Encargado', ref: sigEncargado}, {label: 'Cliente', ref: sigCliente} ].map((f, i) => (
                      <Box key={i}>
                        <Typography variant="subtitle2" display="block" textAlign="center">Firma {f.label}</Typography>
                        <Box sx={{ border: '1px solid #ccc', bgcolor: '#fafafa',borderRadius:2, width:'auto'}}>
                          <SignatureCanvas ref={f.ref} canvasProps={{width:300, height: 120, className: 'sigCanvas' }} />
                        </Box>
                        <Button size="small" onClick={() => f.ref.current.clear()} 
                                sx={{bgcolor: grey[100], color: 'black', textTransform: 'none', 
                                mr:1, '&:hover': { bgcolor: grey[200] },width: 'auto', my:1}}>
                                  Limpiar
                        </Button>
                      </Box>
                    ))}
                  </Box>
                  {reporteGuardado && formato === 'digital' && pdfArchivoUrl && (
                  <Box sx={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd', height: '500px' }}>
                    <embed
                      src={pdfArchivoUrl}
                      type="application/pdf"
                      width="100%"
                      height="100%"
                    />
                  </Box>
                  )}
                </Box>
              </Paper>
          </Stack>
        ) : (
        <Box sx={{textAlign: 'center',py: 3, px:4,  borderRadius: 2, border: '2px dashed #ccc',width:{sx:'100%',sm:'40%'}}}>
            <Box sx={{display:'flex',flexDirection:'column', alignItems:'center'}}>
              {!pdfArchivoUrl && (
              <Box>
                <Button 
                  variant="contained" 
                  component="label"               
                  sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, '&:hover': { bgcolor: '#333' } }}
                >
                  Seleccionar PDF Escaneado
                  <input type="file" hidden accept=".pdf" onChange={(e) => handleUpload(e, 'pdf_checklist')} />
                </Button>
              </Box>
              )}

              {/* --- PREVISUALIZACIÓN (Si ya hay un archivo) --- */}
              {pdfArchivoUrl && (
                <Box sx={{ width: '100%', position: 'relative'}}>
                  
                  {/* Icono de Tache para eliminar/cambiar (Oculto si ya se guardó) */}
                  {!reporteGuardado && (
                    <IconButton 
                      onClick={() => setPdfArchivoUrl('')} 
                      sx={{ 
                        position: 'absolute', 
                        top: -10, 
                        right: -10, 
                        bgcolor: 'white', 
                        boxShadow: 2,
                        '&:hover': { bgcolor: '#f5f5f5', color: 'error.main' } 
                      }}
                      size="small"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}

                  <Box sx={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd', height:'400px' }}>
                    <embed
                      src={`${pdfArchivoUrl}`}
                      type="application/pdf"
                      width="100%"
                      height="100%"
                    />
                  </Box>
                </Box>
              )}
            </Box>
        </Box>
        )}

        <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'center', mt: 2 }}>
          <Button variant="contained" 
          sx={{bgcolor: grey[100], color: 'black', textTransform: 'none', px: 3, '&:hover': { bgcolor: grey[200] } }}
          onClick={alCerrar}
          startIcon={<ReturnIcon/>}>Regresar al menú</Button>
          <Button variant="contained"
          sx={{bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, '&:hover': { bgcolor: 'black' } }} onClick={guardarNuevoReporte} disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Guardar Reporte"}
          </Button>
        </Stack>
      </Box>

      {reporteGuardado && (
        <Box sx={{py:2,px: 4, borderRadius: 2, bgcolor:grey[200] ,width:{sx:'100%',sm:'40%'},display:'flex',gap:2,flexDirection:'column' }}>
          <Typography variant="h6">Enviar Reporte</Typography>
          
          {/* Destinatario Principal */}
          <TextField 
            fullWidth 
            size="small" 
            placeholder="Para ..." 
            value={emailDestino} 
            error={errorForm && (!emailDestino || !ismailValid(emailDestino))}
            helperText={
              errorForm && !emailDestino 
                ? "El destinatario es obligatorio" 
                : errorForm && !ismailValid(emailDestino) 
                  ? "Formato de correo inválido" 
                  : ""
            }         
            onChange={(e) => {
              setEmailDestino(e.target.value);
              if(errorForm) setErrorForm(false); // Limpia el error al escribir
            }}
            sx={Inputstyle} 
          />

          {/* Correos en Copia (CC) */}
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={emailsCC}
            onChange={(event, newValue) => {
              setEmailsCC(newValue);
              if(errorForm) setErrorForm(false);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip 
                  variant="outlined" 
                  label={option} 
                  {...getTagProps({ index })} 
                  // Opcional: poner el chip en rojo si ese correo específico es inválido
                  color={ismailValid(option) ? "default" : "error"} 
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant='outlined'
                placeholder="CC (presiona Enter para agregar)..."
                size="small"
                // Error si: alguno de los correos en la lista es inválido
                error={errorForm && emailsCC.some(email => !ismailValid(email))}
                helperText={
                  errorForm && emailsCC.some(email => !ismailValid(email)) 
                    ? "Uno o más correos en CC no son válidos" 
                    : ""
                }
                sx={Inputstyle}
              />
            )}
          />

          {/* Mensaje del Correo */}
            <TextField
              fullWidth
              multiline
              rows={3}
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              sx={Inputstyle}
              variant='outlined'
              placeholder="Escriba algún mensaje ..."
            />

          <Box sx={{display:'flex',flexDirection:'row',justifyContent:'end'}}>   
            <Button 
              variant="contained" 
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
              onClick={handleEnviarReporte}
              sx={{ bgcolor: 'black',ml:1, textTransform: 'none',width: { xs: '50%', sm: '40%' } }} 
              disabled={loading || !emailDestino}
            >
              {loading ? "Enviando..." : "Enviar"}
            </Button>
          </Box>
        </Box>
      )}

    </Box>

    <Snackbar open={snackbar.open} autoHideDuration={2000} 
                onClose={() => setSnackbar({...snackbar, open: false})} 
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
          {snackbar.message}
        </Alert>
    </Snackbar>

  </Box>
  );
}